import { render, staticRenderFns } from "./DashboardApproveAdjustment.vue?vue&type=template&id=5a43c244&scoped=true&"
import script from "./DashboardApproveAdjustment.vue?vue&type=script&lang=js&"
export * from "./DashboardApproveAdjustment.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAdjustment.scss?vue&type=style&index=0&id=5a43c244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a43c244",
  null
  
)

export default component.exports